<template>
    <div>
        <rkm-form
            ref="RkmForm"
        >

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input-autocomplete
                        :searchFields="fields"
                        :repository="repositories.medicamento"
                        :request-query-string-params="{
                            exibir_receita: true,
                        }"
                        :text-field="p => `${p.nome}`"
                        :validations="validations.medicamento"
                        label="Medicamento"
                        v-model="model.medicamento"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                color="primary"
                                title="Cadastrar medicamento"
                                @click="$refs.ModalMedicamento.open()"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <ModalMedicamento ref="ModalMedicamento" @saved="handleMedicamento" />
        </rkm-form>
    </div>
</template>

<script>

// Components.
import ModalMedicamento from '@/components/pronto-atendimento/atendimento-medico/components/receita-medica/components/Modal'

//Mixins
import { repository, object } from '@/mixins'

export default {
    components: { ModalMedicamento },
    created() {
        this.repositories = {
            medicamento: this.getConectaSusRepository('cadastro.medicamento.medicamento'),
        }
    },
    computed: {
        fields() {

            return [
                { key: 'nome', searchable: true },
            ]
        },
        validations() {

            return {
                medicamento: { required: true },
            }
        },
    },
    data: () => ({
        model: {
            id: null,
            medicamento: null,
        },
    }),
    methods: {
        save() {

            this.$refs.RkmForm.validate().then(response => {

                if (response) {

                    const medicamento = this.clone(this.model)

                    if (this.hasMedicamento(medicamento.medicamento.id)) {

                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Medicamento já cadastrado!'
                        })

                        return
                    }

                    if (this.index !== null) {

                        Object.assign(this.data.model.medicamentosUsoContinuo[this.index], medicamento)

                    } else {

                        this.data.model.medicamentosUsoContinuo.push(medicamento)
                    }

                    this.$emit('save')
                }
            })
        },
        hasMedicamento(medicamentoId) {

            const medicamentos = this.data.model.medicamentosUsoContinuo

            if (medicamentos.length > 0) {

                return medicamentos.find((m, index) => m.medicamento.id === medicamentoId && index !== this.index)
            }
        },
        load(model) {

            if (model) {

                this.model.medicamento = model.medicamento
            }
        },
        handleMedicamento(item) {

            this.model.medicamento = item
        }
    },
    mixins: [ repository, object ],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
    },
}
</script>